import { CMS_API_ENDPOINTS } from "@/features/shop/cms/config/cmsApiPath";
import { CMS_PREVIEW_HEADER } from "@/features/shop/cms/preview/cmsPreviewToken";
import type {
  CmsPage, CmsPagesResponse, CmsPageDetail, CmsPageDetailResponse,
} from "@/features/shop/cms/types/cms.types";
import { fetcher } from "@/shared/lib/fetcher.client";

export const getCmsPages = async (accessToken: string): Promise<CmsPage[]> => {
  const response = await fetcher.get<CmsPagesResponse>(
    CMS_API_ENDPOINTS.PAGES,
    { headers: { Authorization: `Bearer ${accessToken}` } },
  );

  return response.data.pages;
};

/**
 * Page CMS en ligne ou, avec `previewToken`, le brouillon que désigne le jeton d'aperçu
 * (même format, plus `page.preview`).
 */
export const getCmsPageByCode = async (
  code: string,
  accessToken: string,
  previewToken: string | null = null,
): Promise<CmsPageDetail> => {
  const headers: Record<string, string> = { Authorization: `Bearer ${accessToken}` };
  if (previewToken) headers[CMS_PREVIEW_HEADER] = previewToken;

  const response = await fetcher.get<CmsPageDetailResponse>(
    CMS_API_ENDPOINTS.PAGE_BY_CODE(code),
    { headers },
  );

  return response.data.page;
};
